var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.searchResponse)?_c(_vm.productListComponent,_vm._b({tag:"component",attrs:{"search-request-id":_vm.searchRequestId,"search-response":_vm.searchResponse,"limit-products":_vm.pageSize},on:{"reset-page":_vm.resetPage}},'component',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }